import React, { ReactNode } from 'react';
import { useTranslate } from '@im/react-localization';
import { useHasPermission } from './useHasPermission';

type Props = {
  children: ReactNode;
  fallback?: NonNullable<ReactNode> | null;
  roles: string[];
};

/** Renders `children` when User has at least 1 role in the `roles` prop.
 *
 * For AND logic one entry in the `roles` props can be a list of roles separated
 * by "&" character. Whitespace will be ignored.
 *
 * E.g. User must have role1 OR (role2 AND role3)
 * ```
 * roles = ['role1', 'role2 & role3']
 * ```
 */
export function PermissionGate(props: Props) {
  const { children, fallback, roles } = props;

  const translate = useTranslate();
  const hasPermission = useHasPermission();

  if (hasPermission(roles)) {
    return <>{children}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  return <h2>{translate('Common.UnAuthorized')}</h2>;
}
